import React from 'react';
import { Box } from '@mui/material';
import { useInstatDesign } from '../theme/instatDesign';

/**
 * iOS-style pill: rounded, soft bg, tight padding.
 * tone: 'neutral' | 'accent' | 'success' | 'danger' | 'warning' | 'info' | 'outline'
 */
export default function Pill({
  children,
  tone = 'neutral',
  icon,
  size = 'md',
  onClick,
  sx = {},
}) {
  const d = useInstatDesign();

  const tones = {
    neutral: { bg: 'rgba(120,120,128,0.10)', color: d.colors.text, border: 'transparent' },
    accent:  { bg: d.accentSoft,              color: d.accent,      border: 'transparent' },
    success: { bg: d.colors.successSoft,      color: '#0F7B3C',     border: 'transparent' },
    danger:  { bg: d.colors.dangerSoft,       color: '#A8271F',     border: 'transparent' },
    warning: { bg: d.colors.warningSoft,      color: '#B05E00',     border: 'transparent' },
    info:    { bg: d.colors.infoSoft,         color: d.colors.info, border: 'transparent' },
    outline: { bg: 'transparent',             color: d.colors.text, border: d.colors.dividerStrong },
  };
  const t = tones[tone] || tones.neutral;

  const sizes = {
    sm: { h: 20, px: 1,   fs: 11 },
    md: { h: 24, px: 1.25, fs: 12 },
    lg: { h: 28, px: 1.5,  fs: 13 },
  };
  const s = sizes[size] || sizes.md;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        height: s.h,
        px: s.px,
        bgcolor: t.bg,
        color: t.color,
        border: `1px solid ${t.border}`,
        borderRadius: `${d.radius.pill}px`,
        fontSize: s.fs,
        fontWeight: 600,
        lineHeight: 1,
        cursor: onClick ? 'pointer' : 'default',
        transition: `transform ${d.motion.fast}`,
        ...(onClick && { '&:hover': { transform: 'scale(1.04)' } }),
        ...sx,
      }}
    >
      {icon && <Box sx={{ display: 'inline-flex', mr: 0.25 }}>{icon}</Box>}
      {children}
    </Box>
  );
}
